var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPalm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 6.50002C9.325 12.8417 6.33333 17.3334 6.33333 17.3334H8.83333C10.4 12.5 9.66667 9.07502 9.25 7.33335L8 6.50002ZM11.05 4.96669C11.1917 5.14169 11.3333 5.32502 11.4417 5.51669C12.8667 7.77502 12.5833 10.625 10.9167 12.55C11.6167 10.8417 11.5167 8.82502 10.4583 7.14169C10.3917 7.03335 10.3167 6.94169 10.25 6.84169C9.75834 6.15002 9.13334 5.60002 8.45 5.19169C6.05 5.95835 4.31667 8.20002 4.31667 10.85C4.31667 11.4667 4.40833 12.0584 4.575 12.6084C3.875 11.6334 3.46667 10.4417 3.46667 9.15835C3.46667 7.20002 4.41667 5.46669 5.875 4.38335C4.66667 4.29169 3.38333 4.55835 2.26667 5.25002C1.75 5.59169 1.3 5.98335 0.916668 6.42502C1.375 5.31669 2.16667 4.32502 3.25 3.64169C4.5 2.85835 5.91667 2.60002 7.28334 2.80002C6.94167 2.33335 6.525 1.89169 6.025 1.50002C5.54167 1.15002 5.01667 0.866687 4.46667 0.666687C5.66667 0.70002 6.86667 1.08335 7.89167 1.85835C8.41667 2.25002 8.83333 2.72502 9.16667 3.22502C9.25 3.22502 9.325 3.21669 9.40833 3.21669C12.075 3.21669 14.3333 4.97502 15.0833 7.40002C14.15 6.08335 12.7083 5.19169 11.05 4.96669Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPalm);
export default __webpack_public_path__ + "static/media/palm.084395a7.svg";
export { ForwardRef as ReactComponent };